import { render, staticRenderFns } from "./sub-form-item.vue?vue&type=template&id=561165bf&scoped=true&"
import script from "./sub-form-item.vue?vue&type=script&lang=js&"
export * from "./sub-form-item.vue?vue&type=script&lang=js&"
import style0 from "./sub-form-item.vue?vue&type=style&index=0&id=561165bf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561165bf",
  null
  
)

export default component.exports